/*
 * Copyright (c) 2023. Bolmate B.V.
 */
import './style/createRatingExport.scss';

import {ChangeFunction, Checkbox, CloseButton, Loader, voidFunction, WithBackground} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import React, {MouseEventHandler, useMemo} from 'react';
import {Rating} from "../../../util/types";
import {BolmateButton, DvrdDatePicker} from "../../controls";
import BolRating from "../../bolRating/bolRating";

interface Props {
    onClose: MouseEventHandler;
    onChangeFromDate: ChangeFunction<IDate>;
    onChangeToDate: ChangeFunction<IDate>;
    onToggleAllRatings: ChangeFunction<boolean>;
    onToggleRating: (rating: Rating) => MouseEventHandler;
    onStartExport: MouseEventHandler;
    fromDate: IDate | null;
    toDate: IDate | null;
    onlyRatings: Set<Rating>;
    ean?: string;
    loading: boolean;
    active: boolean;
}

export default function CreateRatingExport(props: Props) {
    const {
        ean, fromDate, onChangeFromDate, onChangeToDate, toDate, onToggleRating, onlyRatings, onStartExport, onClose,
        active, loading, onToggleAllRatings
    } = props;
    const headerTitle = useMemo(() => {
        if (ean) return `Reviews exporteren voor ${ean}`;
        return 'Reviews exporteren';
    }, [ean]);

    function renderBody() {
        const dateFormat = 'DD-MM-YYYY';
        const allSelected = ![1, 2, 3, 4, 5].find((rating: Rating) => !onlyRatings.has(rating));
        const allLabel = allSelected ? 'deselecteren' : 'selecteren';
        return (
            <div className='body-container'>
                <Loader active={loading}/>
                <div className='dates'>
                    <DvrdDatePicker onChange={onChangeFromDate} value={fromDate} label='Vanaf datum'
                                    dateFormat={dateFormat} placeholder='Optioneel' closeOnChange/>
                    <DvrdDatePicker onChange={onChangeToDate} value={toDate} label='T/m datum' dateFormat={dateFormat}
                                    placeholder='Optioneel' closeOnChange/>
                </div>
                <div className='rating-selection'>
                    <strong className='rating-title grid-col-2'>Filteren op score</strong>
                    <Checkbox checked={allSelected} onCheck={onToggleAllRatings} label={`Alles ${allLabel}`}
                              className='grid-col-2'/>
                    <div className='col'>
                        {renderRatingSelect(1)}
                        {renderRatingSelect(2)}
                        {renderRatingSelect(3)}
                    </div>
                    <div className='col'>
                        {renderRatingSelect(4)}
                        {renderRatingSelect(5)}
                    </div>
                </div>
            </div>
        )
    }

    function renderRatingSelect(rating: Rating) {
        return (
            <div className='rating-select' onClick={onToggleRating(rating)}>
                <Checkbox checked={onlyRatings.has(rating)} onCheck={voidFunction}/>
                <BolRating value={rating} staticStars/>
            </div>
        )
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='create-rating-export default-popup'>
                <div className='header-container'>
                    <label className='header-title'>{headerTitle}</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton onClick={onClose} label='Annuleren' disabled={loading} secondary/>
                    <BolmateButton onClick={onStartExport} label='Exporteren' disabled={loading}/>
                </div>
            </div>
        </WithBackground>
    )
}